import { Card, Stack, Typography, Box } from '@mui/material';

import { usePoliciesQuery } from '../../../api/getPolicies';
import MySafeDrive from '../../../assets/icons/MySafeDrive';
import SMARTtrek from '../../../assets/icons/SMARTtrek';
import colors from '../../../constants/colors';
import useAnalytics from '../../../hooks/useAnalytics';
import { LinkWithNoRouter } from '../../styledComponents/Link';

const UBIEnrollmentCard = () => {
  const { track } = useAnalytics();
  const { data: policiesData } = usePoliciesQuery();
  const customerHasSmartTrekPolicy =
    !!policiesData?.ubiEnrollment?.smartTrekEnrolled;

  const learnMoreLink = customerHasSmartTrekPolicy
    ? 'https://csaa-insurance.aaa.com/content/aaa-ie/b2c/en/misc/ubi/smarttrek-app-support.html'
    : 'https://csaa-insurance.aaa.com/content/aaa-ie/b2c/en/misc/mysafedrive/main.html';

  return (
    <Card
      data-testid="ubiCard"
      component={Stack}
      spacing={4}
      sx={{
        boxShadow: '0px 4px 8px rgba(25, 30, 43, 0.08)',
        p: { mobile: 2, tablet: 3, desktop: 2 },
        borderRadius: 2,
        height: 'auto',
      }}
    >
      <Stack
        direction={{ mobile: 'column', tablet: 'row', desktop: 'column' }}
        spacing={{ mobile: 2, tablet: 3, desktop: 2 }}
      >
        <Box
          sx={{
            backgroundColor: colors.csaaGray,
            borderRadius: 1,
            width: { mobile: 1, tablet: '50%', desktop: 1 },
            textAlign: 'center',
            py: 1,
          }}
        >
          {customerHasSmartTrekPolicy ? <SMARTtrek /> : <MySafeDrive />}
        </Box>
        <Stack spacing={1} sx={{
          width: 1
        }}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { mobile: 16, tablet: 18 },
              lineHeight: '25px',
              fontFamily: 'Cabin',
              fontKerning: 'normal',
              color: colors.csaaBlack,
              letterSpacing: '0.4px',
            }}
          >
            {customerHasSmartTrekPolicy ? (
              <>
                SMART<i>trek</i>®
              </>
            ) : (
              'MySafeDrive™'
            )}
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: { mobile: 16, tablet: 18, desktop: 16 },
              lineHeight: '21px',
              fontFamily: 'Cabin',
              fontKerning: 'normal',
              color: colors.csaaDark,
            }}
          >
            All participating drivers:
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: { mobile: 16, tablet: 18, desktop: 16 },
              lineHeight: '21px',
              fontFamily: 'Cabin',
              fontKerning: 'normal',
              color: colors.csaaDark,
            }}
          >
            View driving results and trip history in the{' '}
            {customerHasSmartTrekPolicy ? 'SMARTtrek®' : 'MySafeDrive™'} app.
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: { mobile: 16, tablet: 18, desktop: 16 },
              lineHeight: '21px',
              fontFamily: 'Cabin',
              fontKerning: 'normal',
              color: colors.csaaDark,
            }}
          >
            Don’t have it yet? Download the app and register.
          </Typography>
        </Stack>
        <Stack
          direction="row"
          sx={{
            justifyContent: "flex-end",
            width: { mobile: 1, tablet: '50%', desktop: 1 },
            alignItems: "center"
          }}>
          <LinkWithNoRouter
            sx={{
              p: 1,
              fontSize: { mobile: 16, tablet: 18 },
              fontWeight: 700,
            }}
            href={learnMoreLink}
            target="_blank"
            onClick={() => {
              track('Link Accessed', {
                link: 'Learn more',
                location: customerHasSmartTrekPolicy
                  ? 'SMARTtrek Card'
                  : 'MySafeDrive Card',
                event_type: 'Link Accessed',
              });
            }}
          >
            Learn more
          </LinkWithNoRouter>
        </Stack>
      </Stack>
    </Card>
  );
};

export default UBIEnrollmentCard;
